import {useEffect, useMemo, useState} from "react";
import getData from "../../../api/axiosInstance";
import {Link} from "react-router-dom";
import {ArrowLongRightIcon, ArrowLongUpIcon} from "@heroicons/react/24/outline";

export default function ProfitMarginCardFigure() {
    const [grossProfit, setGrossProfit] = useState(0);
    const [totalSalesRevenue, setTotalSalesRevenue] = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    const token = localStorage.getItem("token");

    const headers = useMemo(() => {
        return {
            'Authorization': `Bearer ${token}`
        };
    }, [token]);

    useEffect(() => {
        setIsLoading(true);

        // Fetch gross profit
        getData(
            '/figures/gross_profit',
            headers,
            setGrossProfit,
            'Error fetching gross profit'
        );

        // Fetch total sales revenue
        getData(
            '/figures/total_sales_revenue',
            headers,
            setTotalSalesRevenue,
            'Error fetching total sales revenue'
        );

        setIsLoading(false);
    }, [headers]);

    // Calculate profit margin
    const calculateProfitMargin = () => {
        if (totalSalesRevenue === 0) return 0;

        const profitMargin = (grossProfit / totalSalesRevenue) * 100;

        // Ensure it doesn't exceed 100%
        return Math.min(profitMargin, 100);
    };

    const profitMargin = calculateProfitMargin();
    const formattedProfitMargin = `${profitMargin.toFixed(2)}%`;

    if (isLoading) {
        return (
            <li className="py-3 sm:py-4">
                <div className="flex items-center space-x-4 text-left p-0">
                    <div className="flex-1 min-w-0">
                        <p className="text-md font-medium text-gray-900 truncate dark:text-white">
                            Average Profit Margin
                        </p>
                        <p className="text-sm text-gray-500">Loading...</p>
                    </div>
                </div>
            </li>
        );
    }

    return (
        <li className="py-3 sm:py-4">
            <Link onClick={() => sessionStorage.setItem('scrollPosition', window.scrollY.toString())}>
                <div className="flex items-center space-x-4 text-left p-0 focus:bg-green-50 dark:focus:bg-cyan-900 hover:bg-green-50 dark:hover:bg-cyan-900">
                    <div className="flex-1 min-w-0">
                        <p className="text-md font-medium text-gray-900 truncate dark:text-white">
                            Average Profit Margin
                        </p>

                        {/* Razmak između "Average Profit Margin" i procenta */}
                        <div className="flex items-center space-x-2 mt-3">
                            <p className={`text-sm ${profitMargin >= 0 ? 'text-green-500' : 'text-red-500'}`}>
                                {formattedProfitMargin}
                            </p>
                            {profitMargin >= 0 ? (
                                <ArrowLongUpIcon strokeWidth={2.5} className="w-4 h-4 text-green-500" />
                            ) : (
                                <ArrowLongUpIcon strokeWidth={2.5} className="w-4 h-4 text-red-500 transform rotate-180" />
                            )}
                        </div>
                    </div>

                    <div className="text-right">
                        <div className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                            {formattedProfitMargin}
                        </div>
                    </div>

                    <div className="ml-2">
                        <ArrowLongRightIcon className="h-5 w-5 text-cyan-800 dark:text-cyan-200" />
                    </div>
                </div>
            </Link>
        </li>
    );
}